import React from "react";
import {Nav, Tab, Card} from "react-bootstrap";
import { Container, Row, Col } from "react-bootstrap";
import RYUSEITAILogo from '../../Assets/RYUSEITAI_ES_Logo.png';
import KanataChibi from '../../Assets/Image/(Singing_with_the_Fishes)_Kanata_Shinkai_Chibi.webp'
import KanataSound from '../../Assets/Sound/vo_kanata_bm_skill_1.mp3'
import ClickMeAnimation from "../Fun/ChibiButton";
import KanataHead from '../../Assets/Image/kanata_head.png'

import NatsumeSS from '../../Assets/Image/(Liar_Game)_Natsume_Sakasaki_Chibi.webp';
import NeroChibi from  '../../Assets/Image/mission_chara_474.webp';

function InterestsCard() {
  return (
    <Card className="box-card">
    <Tab.Container  id="interests-page" defaultActiveKey="Interests">
          <Nav variant="pills" fill className="navi-custom">
            <Nav.Item>
              <Nav.Link eventKey="Interests">Interests</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Faves">Faves</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Ships">Ships</Nav.Link>
            </Nav.Item>
          </Nav>
    <Tab.Content>
            <Tab.Pane eventKey="Interests">
      <Card.Body>
        <div className="interests">
        <p><strong>My current interests are:</strong></p>
          <ul className="bulletsCustom">
            <li>Enstars</li>
            <li>Mahoyaku</li>
            <li>Utapri</li>
            <li>Fire Emblem</li>
            <li>Genshin Impact</li>
            <li>Identity V</li>
          </ul>
        </div>
      </Card.Body>
      </Tab.Pane>
    </Tab.Content>

    <Tab.Content>
    <Tab.Pane eventKey="Faves">
      <Card.Body>
      <div className="interests" style={{textAlign: "center"}}>
          <p className="profile-body">
            <img src={NatsumeSS} style={{display: "inline-block"}} alt="Natsume Sakasaki from Ensemble Stars"/>
            <img src={NeroChibi} style={{display: "inline-block"}} alt="Nero Turner from Mahoyaku"/>
            <img src="https://static.wikia.nocookie.net/gensin-impact/images/d/d4/Icon_Emoji_033_Zhongli_Sipping_tea.png" style={{display: "inline-block"}} alt="Zhongli from Genshin Impact"/>
        </p>
        </div>
      </Card.Body>
      </Tab.Pane>
    </Tab.Content>
    <Tab.Content>
    <Tab.Pane eventKey="Ships">
      <Card.Body>
      <div className="interests">
      <p><strong>My favorite ships are:</strong></p>
          <ul className="bulletsCustom">
          <li>NatsuHokke</li>
          <li>Subanatsu</li>
          <li>The first two as an OT3</li>
          <li>I am preferable to Natsume x Second Years</li>
          </ul>
        </div>
      </Card.Body>
      </Tab.Pane>
    </Tab.Content>
    </Tab.Container>
    <div className="profileFooter">
        <Row>
        <Col xs={4}>
        <img className="logo" src={RYUSEITAILogo}/>
        </Col>
        <Col xs={8}>
        <ClickMeAnimation head={KanataHead} img={KanataChibi} sound={KanataSound}/>
        </Col>
        </Row>
    </div>
    </Card>
  );
}

export default InterestsCard;

